export const UploadConstants = {
  Tabs: {
    Multi: "Multi",
    Single: "Single",
  },
};
